import React from 'react'

export default function RadioCheckedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle
        cx='12'
        cy='12'
        r='11'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
      />
      <circle
        cx='12'
        cy='12'
        r='7'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  )
}
